<template>
  <div class="footer-content">
    <div class="top">
      <div class="left">
        <img class="text1" src="../assets/logo.webp" />
        <div class="content">
          <div class="contact-item">
            P. O BOX 72528-00100, CITY SQUARE, AGHWINS KODHEK ROAD, NAIROBI,
            KENYA
          </div>
          <div class="contact-item">Tel: +254 0790818555</div>
          <div class="contact-item">Mail: absolutecreditlimited@gmail.com</div>
        </div>
      </div>
      <div class="right">
        <div class="title">PAGES</div>
        <div class="content">
          <div class="page" @click="handleClick('/')">Home</div>
          <div class="page" @click="handleClick('/service')">Services</div>
          <div class="page" @click="handleClick('/about')">About US</div>
          <div class="page" @click="handleClick('/legality')">Legality</div>
          <div class="page" @click="handleClick('/contact')">Contact US</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      Copyright 2024 © ABSOLUTE CREDIT KENYA LIMITED All rights reserved
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
  router.push(path);
  window.scrollTo(0, 0);
};
</script>
<style lang="less" scoped>
.top {
  color: #333;
  display: flex;
  justify-content: space-around;
  padding: 0 199px;
  margin-top: 100px;
  font-size: 18px;
  font-weight: bold;
  .left {
    width: 500px;
    .text1 {
      height: 20px;
      object-fit: contain;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 20px;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    text-align: left;
  }

  .page,
  .contact-item {
    font-size: 15px;
    text-align: left;
    font-weight: normal;
  }
  .page {
    line-height: 44px;
    cursor: pointer;
  }
  .contact-item:first-child {
    margin-top: 15px;
  }
  .contact-item:nth-child(2n) {
    margin: 20px 0;
  }
}

.bottom {
  text-align: center;
  font-size: 12px;
  color: #333;
  padding: 24px 0;
}
</style>